import { useCallback } from "react"
import {
    deleteSelectedObjectsAction,
    duplicateSelectedObjectsAction,
    groupSelectedObjectsAction,
} from "../../store/slices/objects.slice/object/selectionActions"
import { useAppDispatch } from "../useRedux"

/**
 * Actions on the current selection.
 *
 * Deliberately subscription-free: this runs once per CanvasItem and once per
 * ObjectsTreeNodeMenu — several hundred instances on a large graphic. It used to subscribe to
 * the selection array plus the objects map and run both wrapper hooks (two DOM-measuring
 * `computeWrapperBounds` calls) on every render, all of it only to have three click handlers
 * ready. The thunks read the same data from the store when they actually run.
 */
const useMultiselectObjectAction = () => {
    const dispatch = useAppDispatch()

    const handleDuplicateObjects = useCallback(
        () => dispatch(duplicateSelectedObjectsAction()),
        [dispatch]
    )

    const handleDeleteObjects = useCallback(
        () => dispatch(deleteSelectedObjectsAction()),
        [dispatch]
    )

    const handleGroupObjects = useCallback(() => dispatch(groupSelectedObjectsAction()), [dispatch])

    return {
        handleDuplicateObjects,
        handleDeleteObjects,
        handleGroupObjects,
    }
}

export default useMultiselectObjectAction
